import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TGetSshKeyRotationTestConnectionRequestSchema,
  TGetSshKeyRotationTestConnectionResponseSchema,
} from "./getSshKeyRotationTestConnection.schema";

export const getSshKeyRotationTestConnection = (axios: IAxiosInstance) => {
  return async (
    params: TGetSshKeyRotationTestConnectionRequestSchema
  ): Promise<TGetSshKeyRotationTestConnectionResponseSchema> => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetSshKeyRotationTestConnectionResponseSchema>
    >("/api/sshKeyRotations/testConnection", {
      params,
    });

    if (!response?.data?.success) {
      throw new Error(
        (response?.data as { message?: string })?.message ??
          "Test connection failed"
      );
    }

    return response?.data
      ?.data as TGetSshKeyRotationTestConnectionResponseSchema;
  };
};
